import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants";

const API_CONTROLLER = "stake";

export class StakeApi {
    static getStakeList(){
        const url = `${ROOT_URL}/${API_CONTROLLER}/list`;
        return authAxios.get(url);
    }

    static getStakeDetail(stakeId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${stakeId}`;
        return authAxios.get(url);
    }

    static updateStakeDetail(stakeId, stakeInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${stakeId}`;
        return authAxios.put(url, stakeInfo);
    }

    static createStake(stakeInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/create`;
        return authAxios.post(url, stakeInfo);
    }

    static getStakeWardList(stakeId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${stakeId}/wards`;
        return authAxios.get(url);
    }

    static createWard(stakeId, wardInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${stakeId}/ward/create`;
        return authAxios.post(url, wardInfo);
    }

    static getStakeOptionList(){
        const url = `${ROOT_URL}/${API_CONTROLLER}/option-list`;
        return authAxios.get(url);
    }

    static getStakeWardOptionsList(stakeId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${stakeId}/ward-options`;
        return authAxios.get(url);
    }

    static deleteWard(stakeId, wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${stakeId}/ward/${wardId}`;
        return authAxios.delete(url);
    }

    static wardTools(wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/ward-tools/${wardId}`;
        return authAxios.get(url);
    }    
}

